import React from 'react';

const TriangleDivider = ({ fromColor = "white", toColor = "pink-50", flip = false }) => {
  const getColor = () => {
    if (typeof toColor === 'string' && toColor.startsWith('#')) {
      return toColor;
    }

    // Si es un color de Tailwind, usamos el valor hexadecimal
    const colorMap = {
      'white': '#ffffff',
      'champagne': '#F7E7CE',
      'sand': '#E6D5AC',
      'beige': '#F5E6CC',
      'ivory': '#FFFFF0',
      'wheat': '#F5DEB3',
      'pearl': '#EAE0C8',
      'gold': '#D4AF37',
      'cream': '#FFEFD5'
    };

    // Quitamos el prefijo 'bg-' si existe
    const cleanColor = toColor.replace('bg-', '');
    return colorMap[cleanColor] || toColor;
  };

  return (
    <div className="w-full relative z-10 -mb-16">
      <svg
        className={`w-full h-32 ${flip ? 'transform rotate-180' : ''}`}
        viewBox="0 0 1200 120"
        preserveAspectRatio="xMidYMid slice"
        style={{
          fill: getColor(),
          backgroundColor: getColor()
        }}
      >
        <defs>
          {/* Definimos un patrón que se repetirá */}
          <pattern
            id="gothicPattern"
            width="150"
            height="120"
            patternUnits="userSpaceOnUse"
          >
            <g style={{ stroke: "currentColor", fill: "none" }}>
              {/* Un solo arco gótico que se repetirá */}
              <path
                d="M0 120 L0 40 Q75 0 150 40 L150 120"
                strokeWidth="1"
              />
              {/* Tracería interior */}
              <path
                d="M0 80 Q75 40 150 80"
                strokeWidth="0.5"
              />
              <path
                d="M75 120 L75 20"
                strokeWidth="0.5"
              />
              {/* Rosetón */}
              <circle
                cx="75"
                cy="50"
                r="10"
                strokeWidth="0.5"
              />
              <path
                d="M65 50 Q75 35 85 50"
                strokeWidth="0.5"
              />
              <path
                d="M65 50 Q75 65 85 50"
                strokeWidth="0.5"
              />
              {/* Trébol */}
              <g transform="translate(75,30)">
                <circle r="3" strokeWidth="0.3" />
                <circle cx="3" cy="-3" r="2" strokeWidth="0.3" />
                <circle cx="-3" cy="-3" r="2" strokeWidth="0.3" />
                <circle cx="0" cy="-4" r="2" strokeWidth="0.3" />
              </g>
            </g>
          </pattern>
        </defs>

        {/* Triángulo base */}
        <path d="M1200 0L0 0 598.97 114.72 1200 0z" transform="scale(1, 2)" />

        {/* Aplicamos el patrón gótico */}
        <rect
          x="0"
          y="0"
          width="1200"
          height="120"
          fill="url(#gothicPattern)"
          style={{ opacity: 0.15 }}
        />

        {/* Detalles de tracería superior */}
        <g style={{ stroke: "currentColor", fill: "none", opacity: 0.15 }}>
          <path d="M0 0 Q600 100 1200 0" strokeWidth="0.5" />
          <path d="M0 10 Q600 110 1200 10" strokeWidth="0.5" />
        </g>
      </svg>
    </div>
  );
};

export default TriangleDivider; 